import React, { useContext} from 'react';
import './privacy-policy.styles.scss';
import { GlobalDispatchContext } from '../../context/globalContextProvider';
import cross from "../../assets/images/cross.png";


const PrivacyPolicy = () => {

    const dispatch = useContext(GlobalDispatchContext);
    

    const closePrivacy = () => {
        dispatch({
            type: 'SET_POLICY_OPEN',
            policyIsOpen: false
        })
    }

    return (
        <div className="privacy-policy-container">
            <div className="close">
                <img src={cross} alt="close" onClick={closePrivacy}/>

            </div>
            <h1>Privacy Policy</h1>

            <p>Ingrid vocals respects the privacy of its users. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your
                 information when you visit our website ingridvocals.netlify,app, 
                 including any other media form, media channel, mobile website, or 
                 mobile application related or connected thereto (collectively, the “Site”). 
                 Please read this privacy policy carefully. 
                 If you do not agree with the terms of this privacy policy, please do not access the site.
            </p>

            <p>
                We reserve the right to make changes to this Privacy Policy at any time and for any reason. 
                We will alert you about any changes by updating the “Last Updated” date of this Privacy Policy. 
                Any changes or modifications will be effective immediately upon posting the updated Privacy Policy on the Site, 
                and you waive the right to receive specific notice of each such change or modification.
            </p>

            <p>
                You are encouraged to periodically review this Privacy Policy to stay informed of updates. 
                You will be deemed to have been made aware of, will be subject to, and will be deemed to have accepted the 
                changes in any revised Privacy Policy by your continued use of the Site after the date such revised Privacy Policy is posted
            </p>

            <h2>COLLECTION OF YOUR INFORMATION</h2>

            <p>The only data collected on this site is your name and email address in the
                 event that you agree to sign up to the mailing list when making a purchase
                 of a sample pack. 
            </p>

            <h2>COOKIES</h2>

            <p>We do not collect cookie data</p>

            <h2>USE OF YOUR INFORMATION</h2>

            <p>This is only kept with your permission so that we can contact you regarding 
                to information and promotions related to Ingrid's Vocals and music projects that 
                she is involved in and of course to send you the digital sample packs that you have
                purchased.
            </p>

            <h2>DISCLOSURE OF YOUR INFORMATION</h2>

            <p>We will never pass on your information to third parties and you can unsubscribe at any time by clicking
                unsubscribe in an email or contacting us through the site.

            </p>

            <button onClick={closePrivacy}>Agree</button>
        </div>

        
    )
}

export default PrivacyPolicy;